import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid'

export const ChatbotCopyWrapper = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(2.5)
}))

export const ToggleStack = styled(Stack)(({theme}) => ({
  flexDirection: 'row',
  gap: theme.spacing(1),
  alignItems: 'center'
}))

export const ChatbotGrid = styled(Grid)(({theme}) => ({
  marginTop: theme.spacing(1)
}))
